export const GET_NOTES = gql`
    query notes($input: NotesInput!) {
        notes(input: $input) {
            id
            createdAt
            subject
            body
            createdBy {
                id
                firstName
                lastName
            }
        }
    }
`;
